import { Flex } from '@reckon-web/flex';
import { useTheme } from '@reckon-web/theme';
import { makeId } from '@reckon-web/utils';
import { Link } from '@reckon-web/link';

export const Logo = ({ testId = 'logo' }) => {
  const theme = useTheme();

  return (
    <Link href="/" id="Header-NextLink-logo">
      <Flex alignItems="center" gap="small">
        <img
          height={theme.sizing.small}
          src="/access-aps-workflow-logo.svg"
          alt="Access APS logo"
          id={makeId('logo', 'img')}
        />
      </Flex>
    </Link>
  );
};
